import React from 'react';
import Icon from '../../../components/AppIcon';

/**
 * Badge component to show if a scan is original or a re-scan
 * @param {Object} props
 * @param {number} props.scanNumber - The sequence number of this scan (1 = original, 2,3,4... = re-scans)
 */
const ScanBadge = ({ scanNumber }) => {
    // Don't show badge for FREE tier scans (scanNumber = null)
    if (!scanNumber) return null;

    const isOriginal = scanNumber === 1;

    if (isOriginal) {
        return (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200">
                <Icon name="Sparkles" size={12} />
                Original
            </span>
        );
    }

    return (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-200">
            <Icon name="RotateCw" size={12} />
            Re-scan #{scanNumber}
        </span>
    );
};

export default ScanBadge;
